export default "/images/medicine.png?90c622c5bf07745b2fef1c0db6944884";